import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetClasseById(id: string, isOpen: boolean) {
  return useQuery(
    [URL.CLASSES_OPERACAO.OBTER_POR_ID(id), id],
    async () => {
      const { data } = await http.get<any, any>(URL.CLASSES_OPERACAO.OBTER_POR_ID(id));
      return data as any;
    },
    {
      enabled: !!id && isOpen,
    }
  );
}

export default useGetClasseById;
